import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useState } from "react";
import { TID } from "@/constants/testIds";
import { ClinivonMark } from "@/components/site/Logo";

const NAV = [
  { id: "services", label: "Services" },
  { id: "methodology", label: "Methodology" },
  { id: "results", label: "Results" },
  { id: "industries", label: "Industries" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-200/70"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid={TID.nav.logo} className="flex items-center gap-2.5 group">
          <ClinivonMark size={40} />
          <div className="leading-none">
            <div className="font-display font-bold text-[#0A2540] text-lg tracking-tight">CLINIVON</div>
            <div className="text-[10px] tracking-[0.25em] text-slate-500 uppercase">Operational Excellence</div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="text-sm font-medium text-slate-700 hover:text-[#0A2540] transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#0A2540] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a href="tel:9429951975" className="flex items-center gap-2 text-sm font-medium text-[#0A2540] hover:text-[#10B981] transition-colors">
            <Phone size={14} /> 942-995-1975
          </a>
          <button
            data-testid={TID.nav.cta}
            onClick={() => scrollTo("contact")}
            className="btn-sharp px-5 py-2.5 bg-[#0A2540] text-white text-sm font-semibold hover:bg-[#061A30] transition-all hover:-translate-y-0.5"
          >
            Book Consultation
          </button>
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white px-6 py-4 space-y-3">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => scrollTo(n.id)} className="block text-sm font-medium text-slate-700 w-full text-left">
              {n.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="w-full btn-sharp px-5 py-2.5 bg-[#0A2540] text-white text-sm font-semibold"
          >
            Book Consultation
          </button>
        </div>
      )}
    </motion.nav>
  );
}
